import LocationAdapter from './location_adapter';

export default class AhoyAdapter {
  static global(){
    if (typeof window.ahoy === "undefined"){
      return this.nullObject();
    }

    return window.ahoy;
  }

  static nullObject(){
    return {
      track: this.noop,
    };
  }

  static noop(){
  }

  static track(){
    this.global().track(...arguments);

    if (this.shouldLogEventOnConsole()) {
      this.logEventOnConsole(...arguments);
    }
  }

  static shouldLogEventOnConsole() {
    return LocationAdapter.search().ahoy_debug === '1';
  }

  static logEventOnConsole(eventName, eventProperties) {
    window.console.warn(eventName, '+++', JSON.stringify(eventProperties));
  }
}
